/**
 * @class CartDrawerTemplate
 * @classdesc The content for the cart drawer
 *
 * @extends Core.SectionComponent
 */
export default class CartDrawerTemplate extends Core.SectionComponent {
}
